export const LIST_ALL_ACTIVITIES = `query ($pageSize: Int, $pageNumber: Int) {
  list_all_activities(page_size: $pageSize, page_number: $pageNumber){
    message
    data {
      _id
      name
      img
      description
      rate
      is_active
      minimum_pax
      maximum_pax
      inclusions
      exclusions
    }
    hasMore
  }
}`;

export const ADD_NEW_ACTIVITY = `mutation ($name: String!, $img: String, $description: String, $rate: Float, $minimum_pax: Int, $maximum_pax: Int, $inclusions: String, $exclusions: String) {
  add_new_activity(name: $name, img: $img, description: $description, rate: $rate, minimum_pax: $minimum_pax, maximum_pax: $maximum_pax, inclusions: $inclusions, exclusions: $exclusions) {
    message
  }
}
`;

export const LIST_ACTIVITY_DETAILS = `query ($id: String) {
  list_activity_details(_id: $id){
    message
    data {
      _id
      name
      img
      description
      rate
      is_active
      minimum_pax
      maximum_pax
      inclusions
      exclusions
    }
  }
}`;

export const ACTIVATE_ACTIVITY = `mutation ($id: String!) {
  activate_activity(_id: $id){
    message
  }
}`;

export const DELETE_ACTIVITY = `mutation ($id: String!) {
  delete_activity(_id: $id){
    message
  }
}`;

export const UPDATE_ACTIVITY = `mutation ($id: String!, $name: String, $img: String, $description: String, $rate: Float, $minimum_pax: Int, $maximum_pax: Int, $inclusions: String, $exclusions: String) {
  update_activity(_id: $id, name: $name, img: $img, description: $description, rate: $rate, minimum_pax: $minimum_pax, maximum_pax: $maximum_pax, inclusions: $inclusions, exclusions: $exclusions) {
    message
  }
}`;
